
import { ToastModel } from "@/interfaces/app/toast-model";
import store from "@/store";
import { defineComponent } from "vue";
import ToastComponent from "@/components/appComponents/ToastComponent.vue";
export default defineComponent({
  name: "DefaultApp",

  components: { ToastComponent },

  computed: {
    toast(): ToastModel {
      return store.getters["app/getToastModal"];
    }
  },
});
